import React, { createContext, useEffect, useState } from "react";

export const BasicContext = createContext({
    PID: "",//控制頁面顯示
    menuData:[] as MenuButtonProps[],
    pageContents: [] as PageContentProps[],//控制頁面顯示
    SPType:"",//20240807 處經理或事業體的分類
    SPGroupID:"",//20240807 處經理或事業體的分類
    /*
        BID: "",//控制按鈕顯示
        ActType: "",
        ActID: "",
        Class1: "",
        Class2: "",
        openCard: false,
    */
    setPID: (pid: string) => { },
    setMenuData: (menudata: MenuButtonProps[]) => { },
    setPageContents: (dataRow: PageContentProps[]) => { },
    setSPType: (SPType:string) => { },
    setSPGroupID: (SPGroupID:string) => { }
    /*
    setActType: (actType: string) => { },
    setActID: (actType: string) => { },
    setClass1: (ID: string) => { }, 
    setClass2: (ID: string) => { },
    setOpenCard: (open: boolean) => { },
    */
});

export const BasicContextProvider = (props: any) => {
    const [PID, setMyPID] = useState<string>("Personal");
    const [menuData, setMyMenuData] = useState<MenuButtonProps[]>([]);
    const [pageContents, setMyPageContents] = useState<PageContentProps[]>([] as PageContentProps[]);
    const [SPType, setMySPType] = useState<string>("");
    const [SPGroupID, setMySPGroupID] = useState<string>("");
    /*
    const [BID, setMyBID] = useState<string>("");
    const [ActType, setMyActType] = useState<string>("");
    const [ActID, setMyActID] = useState<string>("");
    const [Class1, setMyClass1] = useState<string>("");
    const [Class2, setMyClass2] = useState<string>("");
    const [openCard, setMyOpenCard] = useState<boolean>(false);
    */

    
    useEffect(() => {        
        const url: string = `
            ?${PID !=""?"pid="+PID:""}
        `
        window.history.replaceState("", "", url.trim());
    }, [PID])
    

    const setBasicPID = (pid: string) => {
        setMyPID(pid);
    };

    const settBasicMenuData = (menudata: MenuButtonProps[]) => {
        setMyMenuData(menudata);
    };

    const setBasicPageContents = (mc:PageContentProps[]) => {
        setMyPageContents(mc);
    };

    const setBasicSPType= (SPType:string) => {
        setMySPType(SPType);
        //console.log(SPType)
    };

    const setBasicSPGroupID= (SPGroupID:string) => {
        setMySPGroupID(SPGroupID);
        //console.log(SPGroupID)
    };



    /*
    const setBasicBID = (pid: string) => {
        setMyBID(pid);
    };

    const setBasicActType = (actType: string) => {
        setMyActType(actType);
    };

    const setBasicActID = (actID: string) => {
        setMyActID(actID);
    };

    const setBasicClass1 = (ID: string) => {
        setMyClass1(ID);
    };

    const setBasicClass2 = (ID: string) => {
        setMyClass2(ID);
    };

    const setBasicOpenCard = (open: boolean) => {
        setMyOpenCard(open);
    };
    */


    return (
        <BasicContext.Provider
            value={{
                PID: PID,
                menuData:menuData,
                pageContents:pageContents,
                SPType:SPType,
                SPGroupID:SPGroupID,
                /*
                BID: BID,
                ActType: ActType,
                ActID: ActID,
                Class1: Class1,
                Class2: Class2,
                openCard: openCard,
                */ 
                setPID: setBasicPID,
                setMenuData:settBasicMenuData,
                setPageContents:setBasicPageContents,
                setSPType:setBasicSPType,
                setSPGroupID:setBasicSPGroupID
                /*
                setBID: setBasicBID,
                setActType: setBasicActType,
                setActID: setBasicActID,
                setClass1: setBasicClass1,
                setClass2: setBasicClass2,
                setOpenCard: setBasicOpenCard
                */
            }}>
            {props.children}
        </BasicContext.Provider>
    )
}


